module.exports = __webpack_public_path__ + "static/img/spec-top.1bd5bf68.png";